// Module
var code = "<ul> <li ng-repeat=\"__item in  msgTargetArray\"> <p ng-repeat=\"(key, value) in __formCtrl[__item].$error track by $index\" ng-bind=\"_errorMessage[key]\" ng-if=\"value && __formCtrl[__item].$dirty\"></p> </li> </ul>";
// Exports
export default code;